import Vue from 'vue';
import Router from 'vue-router';
import qs from 'qs';
import { getUnionId, getBYDUnionId } from '@/api/api';
import { isWeiXin, isMobile } from '@/common/ts/common';
import SyActivityDemo from './views/samples';
import CMBYZ20230524 from '@/views/20230524CMBYZ';
import YDJM20230515 from '@/views/20230515YDJM';
import CQBGY20230531 from '@/views/20230531CQBGY';
import zmdtl20230530 from '@/views/20230530zmdtl';
import BYD20230621 from '@/views/20230621BYD';
import KHZW20230616 from '@/views/20230616KHZW';
import COOKING20230721 from '@/views/20230721COOKING';
import HHHB20230720 from '@/views/20230720HHHB';
import HLSQZDY20230721 from '@/views/20230721HLSQZDY';
import TYZW20230801 from '@/views/20230801TYZW';
import YSPX20230901 from '@/views/20230901YSPX';
import SYDT20230814 from '@/views/20230814SYDT';
import QCJK20230907 from '@/views/20230907QCJK';
import XLBT20230911 from '@/views/20230911XLBT';
import YXQY20230919 from '@/views/20230919YXQY';
import SDJHC20230921 from '@/views/20230921SDJHC';
import GH18D20230926 from '@/views/20230926GH18D';
import GYPMGG20231018 from '@/views/20231018GYPMGG';
import FMXY20231023 from '@/views/20231023FMXY';
import GDDT20231106 from '@/views/20231106GDDT';
import ZGZJ20231114 from '@/views/20231114ZGZJ';
import zmxcq20231120 from '@/views/20231120zmxcq';
import GPXDPT20231128 from '@/views/20231128GPXDPT';
import DIYEXAM20231125 from '@/views/20231125DIYEXAM';
import ZZYPX20231219 from '@/views/20231219ZZYPX';
import GCYS20231222 from '@/views/20231222GCYS';
import SweetTiger20240105 from '@/views/20240105SweetTiger';
import TYSY20240129 from '@/views/20240129TYSY';
import JJRW20240301 from '@/views/20240301JJRW';
import powerFyoung20240227 from '@/views/20240227powerFyoung';
import CQSJDS20240425 from '@/views/20240425CQSJDS';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'HelloWorld',
      component: () => import('@/views/HelloWorld.vue'),
    },
    // Demo展示
    SyActivityDemo,
    // 2023川美毕业展
    CMBYZ20230524,
    // 移动集梦活动
    YDJM20230515,
    // “重新杯”首届城市儿童公益作品展
    CQBGY20230531,
    // 周末到铜梁
    zmdtl20230530,
    // 2023年比亚迪达人共创大赛
    BYD20230621,
    // 第三届重庆青少年科幻征文大赛
    KHZW20230616,
    // 厨艺三十六计
    COOKING20230721,
    // 2023青少年知识产权绘画海报创意大赛
    HHHB20230720,
    // “欢乐社区总动员”首届水上趣味篮球赛-分享
    HLSQZDY20230721,
    // 2023重庆体育故事征文
    TYZW20230801,
    // 渝商评选
    YSPX20230901,
    // 上游答题系统
    SYDT20230814,
    // 青春健康主题宣传创意作品大赛
    QCJK20230907,
    // 2023重庆市深化“小萝卜头”进校园活动
    XLBT20230911,
    // 2023年专精特新中小企业优秀企业家评选
    YXQY20230919,
    // 2023大渡口美食榜之十大江湖菜评选活动-分享
    SDJHC20230921,
    // 团结奋斗开新局 喜迎工会十八大
    GH18D20230926,
    // 两江新区公益平面广告大赛2023
    GYPMGG20231018,
    // 2023年富民兴渝
    FMXY20231023,
    // 重庆轨道交通出行便捷性调查
    GDDT20231106,
    // 重庆工会职工之家
    ZGZJ20231114,
    // 发现最美新重庆
    zmxcq20231120,
    // 上游新闻“米宝宝街角”惜粮公益服务平台
    GPXDPT20231128,
    // 上游diy答题系统
    DIYEXAM20231125,
    // 第三届重庆市制造业十大影响力年度人物评选
    ZZYPX20231219,
    // 国潮养生
    GCYS20231222,
    // 2024甜甜虎春节行动
    SweetTiger20240105,
    // 2024重庆体育科技嘉年华
    TYSY20240129,
    // 2023十大重庆经济年度人物评选
    JJRW20240301,
    // 我们少年有力量
    powerFyoung20240227,
    // 重庆市农产品加工业设计大赛
    CQSJDS20240425,
    {
      path: '*',
      name: 'not-found',
      component: () => import('@/views/NotFound/Home.vue'),
    },
    {
      path: '/code',
      name: 'code',
      component: () => import('@/components/next/MessageLogin.vue'),
    },
    {
      path: '/BindPhone',
      name: 'BindPhone',
      component: () => import('@/components/next/BindPhone.vue'),
    },
  ],
  // 跳转后回到顶部
  scrollBehavior(to, from, savedPosition): any {
    return (
      savedPosition || {
        x: 0,
        y: 0,
      }
    );
  },
});

router.beforeEach(async (to: any, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  // 以下操作均在微信环境中生效
  if (!isWeiXin()) {
    next();
    return;
  }
  const { code } = qs.parse(location.search, {
    ignoreQueryPrefix: true,
  });
  // 控制微信授权是否启用
  if (to.meta.customWeChatAuth) {
    console.log('第三方公众号, 不默认拉取用户信息');
  } else if (code && !localStorage.getItem('unionid')) {
    console.log('request wx user info');
    let res: any = '';
    if (window.location.href.indexOf('BYD0621') > -1) {
      res = await getBYDUnionId({ code });
    } else {
      res = await getUnionId({ code });
    }
    if (res.code === 200) {
      console.log('res.data878738475o3874', res.data);
      window.localStorage.setItem('unionid', res.data.openId);
      window.localStorage.setItem('nickname', res.data.nickname);
      window.localStorage.setItem('headimgurl', res.data.headimgurl);
      // 应将用户微信信息整体存入localStorage
      localStorage.setItem('syWeChatUserInfo', JSON.stringify(res.data));
    } else {
      console.log('清理过期的code');
      // !query中清理过期code字段, 防止用户分享携带有自己的code的页面给其他人，导致无法进行授权登录的状况
      const queries = to.query;
      let strings = '';
      Object.keys(queries).forEach((item: any) => {
        if (item !== 'code') {
          strings += `${item}=${queries[item]}&`;
        }
      });
      strings = strings.slice(0, strings.length - 1);
      location.href = `${window.location.origin}${window.location.pathname}?${strings}`;
    }
  } else {
    console.log('例外');
  }
  next();
});

router.onError((error) => {
  // PC微信解析一个异步组件异常时错误收集
  if (isWeiXin() && !isMobile()) {
    const el = document.createElement('p');
    el.innerHTML = '请复制链接在Chrome, QQ, 360极速/安全等现代浏览器中打开';
    el.style.textAlign = 'center';
    document.body.innerHTML = '';
    document.body.appendChild(el);
  }
  const pattern = /Loading chunk (\d)+ failed/g;
  const isChunkLoadFailed = error.message.match(pattern);
  const targetPath = (router as Router & { history: any }).history.pending
    .fullPath;
  if (isChunkLoadFailed) {
    router.replace(targetPath);
  }
});

export default router;
